import { DependencyList, EffectCallback, useEffect, useRef } from "react"

/**
 * Similar hook to useEffect, but it doesn't run the first effect (on render).
 */
export default function useUpdateEffect(effect: EffectCallback, deps: DependencyList = []): void {
    const isFirstRun = useRef(true)
    useEffect(() => {
        if (!isFirstRun.current) {
            isFirstRun.current = false
            return
        }

        return effect()
    }, deps)
}